





























import { isNumber } from 'lodash-es';
import { computed, defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    visible: { type: Boolean, default: true },
    coverUrl: { type: String, default: '' },
    process: { type: Number, default: undefined },
    isInProcess: { type: Boolean, default: true },
    isRenderError: { type: Boolean, default: false },
    isOverRetryLimit: { type: Boolean, default: false },
    loadingHeight: { type: Number, default: 4 },
  },

  setup(props, { emit }) {
    const isShowProcessNumber = computed(() => props.process !== undefined && isNumber(props.process));

    function onDelete() {
      emit('delete');
    }

    return {
      isShowProcessNumber,
      onDelete,
    };
  },
});
